import Vue from 'vue';
import Vant from 'vant';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vant/lib/index.css';
import './assets/styles/global.css';
import './assets/iconfont/iconfont.css';
// eslint-disable-next-line import/order
import axios from 'axios';

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(Vant);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
